<template>
    <div class="task-views">
        <table>
            <thead>
            <tr>
                <th colspan="2" style=" text-align: left; vertical-align: middle; padding: 0px;padding : 20px 10px;">
                    <swb-task-symb :taskPhaseConf="taskPhaseConf"></swb-task-symb>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="taskData in innerList" style="border-top: 1px dotted #AAAAAA;">
                <td style="padding : 10px 0px; min-width : 90px !important; ">
                    <div class="line-label">{{actorMode ? taskData.theActor : taskData.theDate}}</div>
                </td>
                <td style="padding : 10px 0px; width : 90% !important;">
                    <swb-task-line :startTime="startTime" :endTime="endTime" :specialHours="specialHours" :taskNodeConf="taskNodeConf" :taskPhaseConf="taskPhaseConf" :taskPhaseInfoProvider="taskPhaseInfoProvider" :taskClickHandler="taskClickHandler" :taskData="taskData"></swb-task-line>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import TaskSymb from './TaskSymb.vue';
    import TaskLine from './TaskLine.vue';

    Vue.regist(TaskSymb);
    Vue.regist(TaskLine);
    //
    export default {
        name: 'swb-task-views',
        desc: '任务时间视图',
        components: {TaskSymb, TaskLine},
        props: {
            actorMode: {
                type: Boolean,
                default: false
            },
            //
            startTime: {
                type: String,
                default: '08:00'
            },
            endTime: {
                type: String,
                default: '20:00'
            },
            specialHours: {
                type: Array
            },
            taskNodeConf: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            taskPhaseConf: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            taskPhaseInfoProvider: {
                type: Function
            },
            taskClickHandler: {
                type: Function
            },
            //
            dataList: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data() {
            return {
                innerList: []
            };
        },
        watch: {
            actorMode(newVal, oldVal) {
                this.doInit();
            },
            startTime(newVal, oldVal) {
                this.doInit();
            },
            endTime(newVal, oldVal) {
                this.doInit();
            },
            dataList(newVal, oldVal) {
                this.doInit();
            }
        },
        created() {
            this.doInit();
        },
        methods: {
            doInit() {
                this.innerList = this.dataList || [];
            }
        }
    }
</script>


<style>
    .task-views {
        padding: 10px;
    }

    .task-views .simple-tbl {
        min-width: 400px;
        width: 800px;
    }

    .task-views .line-label {
        display: inline-block;
        padding: 10px;
    }


</style>



// WEBPACK FOOTER //
// src/compo/task/TaskViews.vue